import React from 'react';
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
} from '@mui/material';
import PropTypes from 'prop-types';
import CellValue from './cell-value.component';
import ListData from './list-data.component';
import { AVAILABILITY_LIST_COLUMNS } from '../../config/module-configs/content-sources.config';
import CELL_DATA_TYPES from '../../config/cell-types.config';

const ViewContentSourceData = ({ columns, row, handleDownloadFile }) => (
  <TableContainer component={Paper}>
    <Table>
      <TableBody>
        {columns.map((c) => (
          <TableRow key={`col-${c.id}`}>
            <TableCell
              width="25%"
              variant="head"
              sx={{ border: 0, verticalAlign: 'top' }}
            >
              {c.label}
            </TableCell>
            <TableCell
              width="75%"
              variant="body"
              sx={{ border: 0, verticalAlign: 'top' }}
            >
              {c.type === CELL_DATA_TYPES.TABLE ? (
                <ListData
                  columns={AVAILABILITY_LIST_COLUMNS}
                  rows={row[c.dataKey]}
                  page={null}
                  rowsPerPage={null}
                  totalRows={null}
                  loading={null}
                  actions={[]}
                  error={null}
                  sortBy={null}
                  sortOrder={null}
                  onPageChange={() => {}}
                  onRowsPerPageChange={() => {}}
                  onSortChange={() => {}}
                />
              ) : (
                <CellValue
                  type={c.type}
                  dataKey={c.dataKey}
                  value={row[c.dataKey]}
                  handleDownloadFile={handleDownloadFile}
                />
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

ViewContentSourceData.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  row: PropTypes.shape().isRequired,
  handleDownloadFile: PropTypes.func.isRequired,
};

export default ViewContentSourceData;
